export enum CronoErrorCode {
  BadRequest = 'BadRequest',
  EntityNotFound = 'EntityNotFound',
  EntityNotConsistent = 'EntityNotConsistent',
  EntityNotCreated = 'EntityNotCreated',
  EntityNotUpdated = 'EntityNotUpdated',
  CrmConflictError = 'CrmConflictError',
  CronoConflictError = 'CronoConflictError',
  InternalError = 'InternalError',
  LogFailed = 'LogFailed',
  SalesforceTokenExpired = 'SalesforceTokenExpired',
  SalesforceRefreshTokenExpired = 'SalesforceRefreshTokenExpired',
  SalesforceRefreshTokenMissing = 'SalesforceRefreshTokenMissing',
  SalesforeResponseNotValid = 'SalesforeResponseNotValid',
  IntegrationNotValidError = 'IntegrationNotValidError',
  IntegrationApiError = 'IntegrationApiError',
  IntegrationNotEnabledError = 'IntegrationNotEnabledError',
  GoogleTokenExpired = 'GoogleTokenExpired',
  GoogleRefreshTokenExpired = 'GoogleRefreshTokenExpired',
  GoogleRefreshTokenMissing = 'GoogleRefreshTokenMissing',
  GoogleApiFailed = 'GoogleApiFailed',
  GoogleApiPermissionMissing = 'GoogleApiPermissionMissing',
  HubspotTokenExpired = 'HubspotTokenExpired',
  HubspotRefreshTokenExpired = 'HubspotRefreshTokenExpired',
  HubspotRefreshTokenMissing = 'HubspotRefreshTokenMissing',
  HubspotWebhookTooOld = 'HubspotWebhookTooOld',
  HubspotWebhookInvalidSignature = 'HubspotWebhookInvalidSignature',
  HubspotWebhookInvalidHeaders = 'HubspotWebhookInvalidHeaders',
  HubspotMissingScopes = 'HubspotMissingScopes',
  AttioMissingScopes = 'AttioMissingScopes',
  CrmPropertyCreationNotAllowed = 'CrmPropertyCreationNotAllowed',
  ScrapeNotEnabled = 'ScrapeNotEnabled',
  HunterGetError = 'HunterGetError',
  ScrapeRequestsFinished = 'ScrapeRequestsFinished',
  ScrapeNotFoundError = 'ScrapeNotFoundError',
  ScrapeInvalidUrl = 'ScrapeInvalidUrl',
  ScrapeNotCompleted = 'ScrapeNotCompleted',
  ProspeoGetError = 'ProspeoGetError',
  DatagmaGetError = 'DatagmaGetError',
  SubscriptionInactive = 'SubscriptionInactive',
  SubscriptionExpired = 'SubscriptionExpired',
  SubscriptionMaxUsersReached = 'SubscriptionMaxUsersReached',
  SubscriptionInvalidIntegrationType = 'SubscriptionInvalidIntegrationType',
  ImportError = 'ImportError',
  MaxActiveAccountsNumberExceeded = 'MaxActiveAccountsNumberExceeded',
  PipedriveTokenExpired = 'PipedriveTokenExpired',
  PipedriveRefreshTokenExpired = 'PipedriveRefreshTokenExpired',
  PipedriveRefreshTokenMissing = 'PipedriveRefreshTokenMissing',
  PipedriveResponseNotValid = 'PipedriveResponseNotValid',
  AssistantNotEnabled = 'AssistantNotEnabled',
  GPTError = 'GPTError',
  AssistantRequestsFinished = 'AssistantRequestsFinished',
  // JuneLogError = 'JuneLogError', //exists on the old data, but no more used
  LogError = 'LogError',
  AutomationFailedProspectNotActive = 'AutomationFailedProspectNotActive',
  AutomationFailedProspectNotAssigned = 'AutomationFailedProspectNotAssigned',
  AutomationFailedAccountNotActive = 'AutomationFailedAccountNotActive',
  AutomationFailedEmailSend = 'AutomationFailedEmailSend',
  AutomationFailedAddressMissing = 'AutomationFailedAddressMissing',
  AutomationFailedTemplateMissing = 'AutomationFailedTemplateMissing',
  AutomationFailedEmailCreation = 'AutomationFailedEmailCreation',
  AutomationFailedEmailSettingsMissing = 'AutomationFailedEmailSettingsMissing',
  AutomationFailedTemplateApplicationError = 'AutomationFailedTemplateApplicationError',
  AutomationFailedUnsupportedTaskTypeError = 'AutomationFailedUnsupportedTaskTypeError',
  AutomationFailedLinkedinStatusUnknown = 'AutomationFailedLinkedinStatusUnknown',
  AutomationFailedLinkedinSendMessage = 'AutomationFailedLinkedinSendMessage',
  AutomationFailedLinkedinInvitationLimitReached = 'AutomationFailedLinkedinInvitationLimitReached',
  AutomationFailedLinkedinInvitationMaxCharacters = 'AutomationFailedLinkedinInvitationMaxCharacters',
  AutomationFailedLinkedinInvitationRecentlyWithdrawn = 'AutomationFailedLinkedinInvitationRecentlyWithdrawn',
  AutomationFailedLinkedinUrlMissing = 'AutomationFailedLinkedinUrlMissing',
  AutomationFailedLinkedinInvitationPending = 'AutomationFailedLinkedinInvitationPending',
  AutomationFailedEmailNotValid = 'AutomationFailedEmailNotValid',
  AutomationFailedSalesNavNotLogged = 'AutomationFailedSalesNavNotLogged',
  AutomationFailedSalesNavNotConnected = 'AutomationFailedSalesNavNotConnected',
  AutomationFailedMessageToNotConnected = 'AutomationFailedMessageToNotConnected',
  AutomationFailedLinkedinUrlInvalid = 'AutomationFailedLinkedinUrlInvalid',
  AutomationFailedEmailFormatNotValid = 'AutomationFailedEmailFormatNotValid',
  AutomationFailedProfileViewError = 'AutomationFailedProfileViewError',
  AutomationFailedLikeLastPostError = 'AutomationFailedLikeLastPostError',
  AutomationFailedLinkedinInMailCharsLimit = 'AutomationFailedLinkedinInMailCharsLimit',
  AutomationFailedThreadNotFound = 'AutomationFailedThreadNotFound',
  AutomationFailedPreviousTaskPending = 'AutomationFailedPreviousTaskPending',
  DailySendLimitReached = 'DailySendLimitReached',
  TaskErrorEmailBounced = 'TaskErrorEmailBounced',
  UploadToS3Error = 'UploadToS3Error',
  GetFileFromS3Error = 'GetFileFromS3Error',
  UploadAttachmentError = 'UploadAttachmentError',
  DeleteFileFromS3Error = 'DeleteFileFromS3Error',
  ProgressSyncError = 'ProgressSyncError',
  SyncFromListError = 'SyncFromListError',
  SyncFromListEmpty = 'SyncFromListEmpty',
  ImportStuckError = 'ImportStuckError',
  OutlookTokenExpired = 'OutlookTokenExpired',
  OutlookRefreshTokenExpired = 'OutlookRefreshTokenExpired',
  OutlookRefreshTokenMissing = 'OutlookRefreshTokenMissing',
  OutlookApiFailed = 'OutlookApiFailed',
  OutlookApiPermissionMissing = 'OutlookApiPermissionMissing',
  OutlookThrottled = 'OutlookThrottled',
  OutlookRequestTimeout = 'OutlookRequestTimeout',
  OutlookSendOutcomeUnknown = 'OutlookSendOutcomeUnknown',
  AircallTokenMissing = 'AircallTokenMissing',
  AircallTokenExpired = 'AircallTokenExpired',
  MigrationError = 'MigrationError',
  MigrationNotActiveError = 'MigrationNotActiveError',
  ErrorAttachmentsLimitReached = 'ErrorAttachmentsLimitReached',
  MailBoxNotPresent = 'MailBoxNotPresent',
  NoMailBoxConnected = 'NoMailBoxConnected',
  MailBoxDisconnected = 'MailBoxDisconnected',
  AutomationFailedMaxSendEmailLimit = 'AutomationFailedMaxSendEmailLimit',

  ProspectOptedOut = 'ProspectOptedOut',

  GenerateAiVariableEntityNotFound = 'GenerateAiVariableEntityNotFound',
  GenerateAiVariableVariableNotFound = 'GenerateAiVariableVariableNotFound',
  GenerateAiVariablePromptError = 'GenerateAiVariablePromptError',
  GenerateAiVariableVariableMissingError = 'GenerateAiVariableVariableMissingError',
  GenerateAiVariableVariableEmptyPromptError = 'GenerateAiVariableVariableEmptyPromptError',
  GenerateAiVariableInternalError = 'GenerateAiVariableInternalError',

  GenericError = 'GenericError',
}
